var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-auditor" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("\n    用印审批\n  ")]),
      _vm._l(_vm.signAuditor, function(item, i) {
        return [
          _c("div", { key: "signAuditor_0" + i, staticClass: "item" }, [
            _c("div", { staticClass: "desc" }, [
              _c("div", [
                _c("img", {
                  attrs: {
                    width: "113px",
                    src: _vm.fileOperShow(item),
                    title: item.sealName
                  }
                })
              ]),
              _c("div", { staticStyle: { "margin-left": "30px" } }, [
                _c("p", { staticClass: "userName" }, [
                  _vm._v(_vm._s(item.sealName))
                ]),
                _c("p", { staticClass: "user-tilte-color" }, [
                  _vm._v("\n            申请人：\n          ")
                ]),
                _c("p", { staticClass: "userName" }, [
                  _vm._v(_vm._s(item.initiateName))
                ]),
                item.taskDetail
                  ? _c("p", [_vm._v(_vm._s(item.taskDetail.taskCreateTime))])
                  : _vm._e()
              ])
            ])
          ]),
          _c("div", { key: "signAuditor_" + i, staticClass: "content" }, [
            _c("p", { staticClass: "tit" }, [
              _vm._v(
                "\n        共" +
                  _vm._s(
                    (item.taskDetail &&
                      item.taskDetail.nodes &&
                      item.taskDetail.nodes.length) ||
                      0
                  ) +
                  "方\n      "
              )
            ]),
            item.taskDetail
              ? _c(
                  "div",
                  { staticClass: "obj-box" },
                  [
                    _vm._l(item.taskDetail.nodes || [], function(v, index) {
                      return _vm._l(v.taskList || [], function(apUser, i) {
                        return _c(
                          "div",
                          { key: index + "_" + i, staticClass: "obj" },
                          [
                            apUser.userId === _vm.dingTalkUserId
                              ? [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: apUser.name + "(我)",
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "user" }, [
                                        _c("span", {
                                          staticClass: "el-icon-user-solid"
                                        })
                                      ])
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: apUser.name,
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "user" }, [
                                        _c("span", {
                                          staticClass: "el-icon-user-solid"
                                        })
                                      ])
                                    ]
                                  )
                                ],
                            _c("div", { staticClass: "obj-other" }, [
                              _c("p", { staticClass: "userName" }, [
                                _vm._v(_vm._s(apUser.name))
                              ]),
                              _vm.comstatus(apUser) === 1
                                ? _c(
                                    "div",
                                    { staticClass: "status text-color-green" },
                                    [
                                      _vm._v(
                                        "\n                已同意\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.comstatus(apUser) === 2
                                ? _c(
                                    "div",
                                    { staticClass: "status text-color-red" },
                                    [
                                      _vm._v(
                                        "\n                已驳回\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.comstatus(apUser) === 0
                                ? _c("div", { staticClass: "status" }, [
                                    _vm._v("未审批")
                                  ])
                                : _vm._e(),
                              apUser.finishTime
                                ? _c("div", { staticClass: "time" }, [
                                    _vm._v(_vm._s(apUser.finishTime))
                                  ])
                                : _vm._e()
                            ]),
                            _vm.comstatus(apUser) === 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "approver-bth-sty",
                                    attrs: {
                                      plain: "",
                                      type: "primary",
                                      size: "small",
                                      disabled:
                                        !!(
                                          item.taskDetail.node &&
                                          item.taskDetail.nodes.length > 1
                                        ) &&
                                        _vm.indexFlowStatus(
                                          item.taskDetail.nodes
                                        ) !== index
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.urgentReview({
                                          user: apUser,
                                          item: item
                                        })
                                      }
                                    }
                                  },
                                  [_vm._v("催审")]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      })
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78bae384", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78bae384","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/auditDetail/dingSignApprove.vue
// module id = q1M+
// module chunks = 13 14 17 26 32